import React, { useEffect, useMemo, useState } from "react";
import Navigation from "../Components/Navigation";
import API from "../api/config.js";

// Icons
const EyeIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor">
    <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Z" strokeWidth="2" />
    <circle cx="12" cy="12" r="3" strokeWidth="2" />
  </svg>
);

 const EditIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor">
    <path d="M12 20h9" strokeWidth="2" strokeLinecap="round" />
    <path
      d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const TrashIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor">
    <path d="M4 7h16M10 11v6m4-6v6M9 7V5h6v2m-8 0 1 12h8l1-12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ActionBtn = ({ title, onClick, children }) => (
  <button
    type="button"
    title={title}
    onClick={onClick}
    className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
  >
    {children}
  </button>
);

const StatusPill = ({ status }) => {
  const map =
    status?.toUpperCase() === "OPEN"
      ? "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300"
      : status?.toUpperCase() === "RESOLVED"
      ? "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300"
      : "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300";
  return <span className={`px-3 py-1 rounded-full text-xs font-semibold ${map}`}>{status || "—"}</span>;
};

const typeOptions = ["All Types", "Sticker",  "Tag", ];
const statusOptions = ["All Status", "Request", "Delivered"];

const Requests = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem("travelxoxo-theme") || "light");
  const [activeScreen, setActiveScreen] = useState("requests");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  // Controls
  const [query, setQuery] = useState("");
  const [typeFilter, setTypeFilter] = useState("All Types");
  const [statusFilter, setStatusFilter] = useState("All Status");
  const [sortBy, setSortBy] = useState("created_desc");

  // Modal
  const [viewRow, setViewRow] = useState(null);
  const [editRow, setEditRow] = useState(null);

  const [page, setPage] = useState(1);
const PAGE_SIZE = 50; // or 100 as you want


  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("travelxoxo-theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === "light" ? "dark" : "light"));

  const fetchUsers= async () => {
    try {
      setLoading(true);
      const { data } = await API.get("/requests");
      const mapped = (data || []).map((r) => ({
        id: r.id,
        qr_id: r.qr_id || "",
        type: r.type || "Other",
        name: r.name || "",
        email: r.email || "",
        phone: r.phone || "",
        address: r.address || "",
        qr_quantity: r.qr_quantity || 0,
        qr_type: r.qr_type || "",
        status: r.status || "Open",
        created_at: r.created_at || null,
       
      }));
      setRows(mapped);
    } catch (err) {
      console.error("Error fetching requests:", err);
      alert(`Error: ${err.response?.data?.message || err.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

 
  const filtered = useMemo(() => {
    let list = [...rows];
    const q = query.trim().toLowerCase();
    if (q) {
      list = list.filter(
        (r) =>
          r.qr_id.toLowerCase().includes(q) ||
          r.requester.toLowerCase().includes(q) ||
          r.email.toLowerCase().includes(q) ||
          r.phone.toLowerCase().includes(q)
      );
    }
    if (typeFilter !== "All Types") list = list.filter((r) => r.qr_type === typeFilter);
    if (statusFilter !== "All Status") list = list.filter((r) => r.status === statusFilter);

    list.sort((a, b) => {
      switch (sortBy) {
        case "created_asc": return new Date(a.created_at || 0) - new Date(b.created_at || 0);
        case "created_desc": return new Date(b.created_at || 0) - new Date(a.created_at || 0);
        case "type_asc": return (a.qr_type || "").localeCompare(b.qr_type || "");
        case "status_asc": return (a.status || "").localeCompare(b.status || "");
        default: return 0;
      }
    });
    return list;
  }, [rows, query, typeFilter, statusFilter, sortBy]);


  // Reset to first page when filters/search change
useEffect(() => {
  setPage(1);
}, [query, typeFilter, statusFilter, sortBy]);

// Pagination
const totalPages = Math.ceil(filtered.length / PAGE_SIZE) || 1;
const paginated = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);



  const handleDelete = async (id) => {
    if (!window.confirm("Delete this request?")) return;
    try {
      await API.delete(`/requests/${id}`);
      setRows((prev) => prev.filter((r) => r.id !== id));
    } catch (err) {
      console.error(err);
      alert(`Delete failed: ${err.response?.data?.message || err.message}`);
    }
  };

  //   // SAVE EDIT
  const handleEditSave = async () => {
    try {
      await API.put(`/requests/${editRow.id}`, editRow);
      setRows((prev) => prev.map((r) => (r.id === editRow.id ? editRow : r)));
      setEditRow(null);
    } catch {
      alert("Update failed");
    }
  };



  // export CSV
  // Export CSV based on current filters (ignores pagination)
const exportCSV = () => {
  if (!filtered.length) {
    alert("No data to export");
    return;
  }

  const headers = [
    "Request ID",
    "QR ID",
    "Name",
    "Email",
    "Phone",
    "Address",
    "Quantity",
    "Type",
    "Status",
    "Created At"
  ];

  const rows = filtered.map((r) => [
    r.id,
    r.qr_id,
    `"${r.name || ""}"`,
    r.email,
    r.phone,
    `"${r.address || ""}"`,
    r.qr_quantity,
    r.qr_type,
    r.status,
    r.created_at
  ]);

  let csv = headers.join(",") + "\n";
  rows.forEach((row) => {
    csv += row.join(",") + "\n";
  });

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = "requests_export.csv";
  link.click();

  URL.revokeObjectURL(url);
};

  return (
    <div className="flex bg-gray-50 dark:bg-gray-900 min-h-screen transition-colors duration-300">
      <Navigation activeScreen={activeScreen} setActiveScreen={setActiveScreen} theme={theme} toggleTheme={toggleTheme} />

      <main className="flex-1 ml-20 md:ml-64 p-6 md:p-10">
        <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Requests</h1>
          <div className="flex items-center gap-2">
            
          
            <button onClick={exportCSV} className="inline-flex items-center gap-2 rounded-xl bg-orange-600 px-4 py-2.5 text-white shadow-sm hover:bg-orange-700">
  Export CSV
</button>

          </div>
        </div>

        {/* Controls */}
        <div className="grid gap-3 md:grid-cols-4 mb-5">
          <div className="col-span-1">
            <div className="relative">
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search requests..."
                className="w-full rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-gray-800 placeholder-gray-400 focus:border-gray-400 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100"
              />
              <span className="pointer-events-none absolute right-3 top-2.5 text-gray-400">⌘K</span>
            </div>
          </div>

          <div>
            <select
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
              className="w-full appearance-none rounded-xl border border-gray-200 bg-white px-4 py-2.5 pr-10 text-gray-800 focus:border-gray-400 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100"
            >
              {typeOptions.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </div>

          <div>
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="w-full appearance-none rounded-xl border border-gray-200 bg-white px-4 py-2.5 pr-10 text-gray-800 focus:border-gray-400 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100"
            >
              {statusOptions.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </div>

          <div>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="w-full appearance-none rounded-xl border border-gray-200 bg-white px-4 py-2.5 pr-10 text-gray-800 focus:border-gray-400 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100"
            >
              <option value="created_desc">Newest First</option>
              <option value="created_asc">Oldest First</option>
              <option value="type_asc">Type (A → Z)</option>
              <option value="status_asc">Status (A → Z)</option>
            </select>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800">
          <div className="overflow-x-auto">
            <table className="min-w-full text-left text-sm">
              <thead className="bg-gray-50 text-gray-600 dark:bg-gray-900/40 dark:text-gray-300">
                <tr>
                  <th className="px-6 py-4 font-semibold">Request ID</th>
                  <th className="px-6 py-4 font-semibold">Name</th>
                  <th className="px-6 py-4 font-semibold">Contact</th>
                  <th className="px-6 py-4 font-semibold">Email</th>
                  <th className="px-6 py-4 font-semibold">Address</th>
                  <th className="px-6 py-4 font-semibold">Quantity</th>
                  <th className="px-6 py-4 font-semibold">Type</th>
                  <th className="px-6 py-4 font-semibold">Status</th>
                  <th className="px-6 py-4 font-semibold text-right">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                {loading && (
                  <tr>
                    <td colSpan={9} className="px-6 py-12 text-center text-gray-500 dark:text-gray-400">
                      Loading…
                    </td>
                  </tr>
                )}

                {!loading && filtered.length === 0 && (
                  <tr>
                    <td colSpan={9} className="px-6 py-12 text-center text-gray-500 dark:text-gray-400">
                      No requests found.
                    </td>
                  </tr>
                )}

                {!loading &&
                  paginated.map((r) => (

                    <tr key={r.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/50">
                      <td className="px-6 py-4 font-mono text-gray-900 dark:text-gray-100">{r.id}</td>
                      <td className="px-6 py-4 text-gray-900 dark:text-gray-100">{r.name || "—"}</td>
                      <td className="px-6 py-4 text-gray-800 dark:text-gray-200">{r.phone || "—"}</td>
                      <td className="px-6 py-4 text-gray-800 dark:text-gray-200">{r.email || "—"}</td>
                      <td className="px-6 py-4 text-gray-800 dark:text-gray-200">{r.address || "—"}</td>
                      <td className="px-6 py-4 text-gray-800 dark:text-gray-200">{r.qr_quantity || "—"}</td>
                      <td className="px-6 py-4 text-gray-800 dark:text-gray-200">{r.qr_type || "—"}</td>
                      <td className="px-6 py-4">
                        <StatusPill status={r.status} />
                      </td>
                      <td className="px-6 py-4 text-right">
                        <div className="flex items-center justify-end gap-2">
                          <ActionBtn title="View" onClick={() => setViewRow(r)}>
                            <EyeIcon />
                          </ActionBtn>
                           <ActionBtn title="Edit" onClick={() => setEditRow(r)}>
                             <EditIcon />
                         </ActionBtn>

                          <ActionBtn title="Delete" onClick={() => handleDelete(r.id)}>
                            <TrashIcon />
                          </ActionBtn>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* View modal */}
        {viewRow && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={() => setViewRow(null)}>
            <div
              className="rounded-2xl border border-gray-200 bg-white p-6 shadow-xl dark:border-gray-700 dark:bg-gray-800 w-full max-w-lg"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="mb-4 text-sm text-gray-600 dark:text-gray-300">
                Request <span className="font-mono">#{viewRow.id}</span>
                {viewRow.qr_id ? ` • QR ${viewRow.qr_id}` : ""}
              </div>
              <div className="space-y-2 text-gray-800 dark:text-gray-200">
                <div><span className="font-semibold">Type:</span> {viewRow.qr_type}</div>
                <div><span className="font-semibold">Name:</span> {viewRow.name || "—"}</div>
                <div><span className="font-semibold">Email:</span> {viewRow.email || "—"}</div>
                <div><span className="font-semibold">Phone:</span> {viewRow.phone || "—"}</div>
                <div><span className="font-semibold">Status:</span> {viewRow.status}</div>
                <div><span className="font-semibold">Created:</span> {viewRow.created_at || "—"}</div>
               
              </div>
              <div className="mt-6 flex justify-end gap-2">
                <button onClick={() => setViewRow(null)} className="rounded-xl bg-gray-200 px-4 py-2 dark:bg-gray-700 dark:text-gray-100">
                  Close
                </button>
              </div>
            </div>
          </div>
        )}


        {/* Edit Modal */}
        {editRow && (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
    onClick={() => setEditRow(null)}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      className="w-full max-w-lg rounded-2xl bg-white p-6 shadow-xl dark:bg-gray-800 dark:border dark:border-gray-700"
    >
      <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-5">
        Edit Request #{editRow.id}
      </h2>

      <div className="grid gap-4">
        {/* Name */}
        <div>
          <label className="text-sm font-medium text-gray-600 dark:text-gray-300">
            Name
          </label>
          <input
            className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-gray-900 
                       focus:border-orange-500 focus:ring-2 focus:ring-orange-200 
                       dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:focus:border-orange-500"
            value={editRow.name}
            onChange={(e) => setEditRow({ ...editRow, name: e.target.value })}
          />
        </div>

        {/* Email */}
        <div>
          <label className="text-sm font-medium text-gray-600 dark:text-gray-300">
            Email
          </label>
          <input
            className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-gray-900 
                       focus:border-orange-500 focus:ring-2 focus:ring-orange-200 
                       dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:focus:border-orange-500"
            value={editRow.email}
            onChange={(e) => setEditRow({ ...editRow, email: e.target.value })}
          />
        </div>

        {/* Phone */}
        <div>
          <label className="text-sm font-medium text-gray-600 dark:text-gray-300">
            Phone
          </label>
          <input
            className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-gray-900 
                       focus:border-orange-500 focus:ring-2 focus:ring-orange-200 
                       dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:focus:border-orange-500"
            value={editRow.phone}
            onChange={(e) => setEditRow({ ...editRow, phone: e.target.value })}
          />
        </div>

        {/* Address */}
        <div>
          <label className="text-sm font-medium text-gray-600 dark:text-gray-300">
            Address
          </label>
          <input
            className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-gray-900 
                       focus:border-orange-500 focus:ring-2 focus:ring-orange-200 
                       dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:focus:border-orange-500"
            value={editRow.address}
            onChange={(e) => setEditRow({ ...editRow, address: e.target.value })}
          />
        </div>

        {/* Quantity */}
        <div>
          <label className="text-sm font-medium text-gray-600 dark:text-gray-300">
            Quantity
          </label>
          <input
            type="number"
            className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-gray-900 
                       focus:border-orange-500 focus:ring-2 focus:ring-orange-200 
                       dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:focus:border-orange-500"
            value={editRow.qr_quantity}
            onChange={(e) =>
              setEditRow({ ...editRow, qr_quantity: e.target.value })
            }
          />
        </div>

        {/* Type */}
        <div>
          <label className="text-sm font-medium text-gray-600 dark:text-gray-300">
            Type
          </label>
          <select
            className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-gray-900 
                       focus:border-orange-500 focus:ring-2 focus:ring-orange-200 
                       dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:focus:border-orange-500"
            value={editRow.qr_type}
            onChange={(e) =>
              setEditRow({ ...editRow, qr_type: e.target.value })
            }
          >
            {typeOptions.map((t) => (
              <option key={t}>{t}</option>
            ))}
          </select>
        </div>

        {/* Status */}
        <div>
          <label className="text-sm font-medium text-gray-600 dark:text-gray-300">
            Status
          </label>
          <select
            className="mt-1 w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-gray-900 
                       focus:border-orange-500 focus:ring-2 focus:ring-orange-200 
                       dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100 dark:focus:border-orange-500"
            value={editRow.status}
            onChange={(e) =>
              setEditRow({ ...editRow, status: e.target.value })
            }
          >
            {statusOptions.map((s) => (
              <option key={s}>{s}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Buttons */}
      <div className="mt-6 flex justify-end gap-3">
        <button
          onClick={() => setEditRow(null)}
          className="rounded-xl bg-gray-300 px-4 py-2 text-gray-800 hover:bg-gray-400 
                     dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600"
        >
          Cancel
        </button>

        <button
          onClick={handleEditSave}
          className="rounded-xl bg-orange-600 px-4 py-2 text-white hover:bg-orange-700"
        >
          Save
        </button>
      </div>
    </div>
    
  </div>

  
)}



{/* Pagination */}
<div className="flex items-center justify-center gap-2 px-4 py-5">
  
  {/* Prev */}
  <button
    className="rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm 
               text-gray-700 hover:bg-gray-100 disabled:opacity-40 
               dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700"
    onClick={() => setPage((p) => Math.max(1, p - 1))}
    disabled={page === 1}
  >
    ←
  </button>

  {/* Page numbers (max 5 visible) */}
  {Array.from({ length: totalPages }).slice(
    Math.max(0, page - 3),
    Math.min(totalPages, page + 2)
  ).map((_, i) => {
    const n = i + Math.max(1, page - 2);
    const active = n === page;
    return (
      <button
        key={n}
        onClick={() => setPage(n)}
        className={`h-10 w-10 rounded-xl text-sm font-semibold transition ${
          active
            ? "bg-orange-600 text-white shadow"
            : "border border-gray-300 bg-white text-gray-700 hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700"
        }`}
      >
        {n}
      </button>
    );
  })}

  {/* Next */}
  <button
    className="rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm 
               text-gray-700 hover:bg-gray-100 disabled:opacity-40 
               dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700"
    onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
    disabled={page === totalPages}
  >
    →
  </button>
</div>





      </main>


    </div>



     
  );
};

export default Requests;


